import { LoanApplicationService } from '../loan-application.service';
import { MatSnackBar } from '@angular/material';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../../analytics.service';
var PageTwoComponent = /** @class */ (function () {
    function PageTwoComponent(loan, router, analytics, snackBar) {
        this.loan = loan;
        this.router = router;
        this.analytics = analytics;
        this.snackBar = snackBar;
        this.posting = new BehaviorSubject(false);
    }
    PageTwoComponent.prototype.backward = function () {
        this.loan.backward();
    };
    PageTwoComponent.prototype.sendLoanApplication = function () {
        var _this = this;
        if (this.isValid) {
            this.posting.next(true);
            this.loan
                .postLoanApplication()
                .do(function () { return _this.posting.next(false); })
                .subscribe(function (loan) {
                _this.analytics.dataLayer({
                    virtualPageURL: '/thank-you',
                    virtualCustomerType: loan.employment_type,
                    virtualtrigger: 'loan_app_success_ok',
                    userEmail: _this.userEmail,
                });
                _this.router.navigate(['/thank-you']);
            }, function (e) {
                var key = Object.keys(e.error)[0].replace(/_/g, " ");
                var info = key ? "Invalid " + key : 'Something went wrong';
                _this.snackBar.open(info + ". Please review your information and try again.", 'Close', {
                    duration: 3000,
                });
                console.error("Received API error:", JSON.stringify(e.error));
                _this.posting.next(false);
                _this.markAllDirty(_this.loan.form);
            });
        }
        else {
            this.posting.next(false);
            this.markAllDirty(this.loan.form);
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
    };
    Object.defineProperty(PageTwoComponent.prototype, "isValid", {
        get: function () {
            return this.loan.form.valid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageTwoComponent.prototype, "userEmail", {
        get: function () {
            return this.loan.form.get('personal_info.email_addresses.0').value;
        },
        enumerable: true,
        configurable: true
    });
    PageTwoComponent.prototype.markAllDirty = function (control) {
        if (control.hasOwnProperty('controls')) {
            control.markAsDirty();
            var ctrl = control;
            for (var _i = 0, _a = Object.keys(ctrl.controls); _i < _a.length; _i++) {
                var inner = _a[_i];
                this.markAllDirty(ctrl.controls[inner]);
            }
        }
        else {
            (control).markAsDirty();
            (control).markAsTouched();
        }
    };
    return PageTwoComponent;
}());
export { PageTwoComponent };
